import { Rewards } from '@arrived/models';

import { rewardsApi } from '../api';

export async function getAccountVouchers(accountUuid: string) {
  const response = await rewardsApi.get<Rewards.VoucherSearchResponse>(`/vouchers?accountUuid=${accountUuid}`);
  return response.data;
}

export async function postAccountVoucher(voucherBody: Rewards.VoucherCreationRequest) {
  const response = await rewardsApi.post<Rewards.Voucher>(`/vouchers`, voucherBody);
  return response.data;
}

export async function postRevokeVoucher(voucherBody: Rewards.Voucher) {
  const response = await rewardsApi.post<Rewards.Voucher>(`/vouchers/${voucherBody.uuid}/revoke`, voucherBody);
  return response.data;
}
